export default __webpack_public_path__ + "static/media/previousimg.47623d52.svg";